export type DocumentKind = "resume" | "cover-letter";

export type DocumentSort = "recent" | "oldest" | "title-ascending" | "title-descending";

export type UserDocument = {
  id: string;
  kind: DocumentKind;
  title: string;
  thumbnailUrl?: string;
  createdAt: string;
  updatedAt: string;
};

export type DocumentAction = "open" | "rename" | "duplicate" | "download" | "delete";

export type DocumentSortOption = {
  label: string;
  value: DocumentSort;
};

export const DOCUMENT_SORT_OPTIONS: DocumentSortOption[] = [
  {
    label: "Plus récents",
    value: "recent",
  },
  {
    label: "Plus anciens",
    value: "oldest",
  },
  {
    label: "Titre : A à Z",
    value: "title-ascending",
  },
  {
    label: "Titre : Z à A",
    value: "title-descending",
  },
];
